// builder-components.ts
import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const CallCampaignButton = dynamic(() => import('./call-campaign-button'));

Builder.registerComponent(CallCampaignButton, {
  name: 'CallCampaignButton',
  noWrap: true,
});
